/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author    Afternet <info@afternet.gr>
 * @copyright 2022 Afternet
 * @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React from 'react';
import PageBox from "../../layouts/pageBox";
import {useTranslation} from "react-i18next";
import SEO from "../../components/SEO";

const HowItWorks = () => {

    const { t, i18n } = useTranslation();

    const data = {
        title:  t('howItWorks.title' ),
        subtitle: ''
    };

    return (
        <PageBox data={data}>
            <SEO
                title={ t('meta_title.howItWorks' )}
                description={ t('meta_description.howItWorks' ) }
            />
            <div className='page-body'>

                <div dangerouslySetInnerHTML={{__html: t('howItWorks.content' ) }} />

            </div>
        </PageBox>
    );
};

export default HowItWorks;
